module.exports = __webpack_public_path__ + "static/Sakoei-9291175732dd55a9ed4e4bc3ac3ffcd5.jpg";